import types from 'constants/actionTypes';
import { combineReducers } from 'redux';
import mergeByIds from '../../utils/mergeByIds';

const initialState = {
  byId: {},
};

const byId = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState.byId;
  }

  switch (type) {
    case types.GET_MODEL_TEMPLATES_WORKING_STATE_REQUEST_SUCCESS:
      return mergeByIds({
        byIdCurrent: state,
        byIdToMerge: payload.entities.templateSubmitted,
      });
    default:
      return state;
  }
};

export default combineReducers({
  byId,
});
